import { EventSourceHandler } from '@sellsy/sse';
import { EVENT_TYPES } from 'Dictionaries/notification/NotificationEnums';

export default class NotificationSentEventSourceHandler extends EventSourceHandler {
    constructor() {
        super();
        this.type = 'staff.notification.sent';
    }

    handle(event) {
        //We need to trigger importStore on ending import notif to update metadata
        if (
            event.data.event === EVENT_TYPES.IMPORT_NOTIFICATION &&
            event.data.status === 'processed'
        ) {
            window.sellsyapp.$store.dispatch(
                'importsStore/updateMetadataAfterImportEnd',
                event.data.type,
            );
        }
        let Notification = require('Services/Notification/Notification').default;
        if (event.data.event === EVENT_TYPES.AGENDA_ALERT_SENT) {
            Notification = require('Services/Notification/ActivityReminderNotification').default;
        }
        new Notification(event.data).notify();
    }
}
